import { render } from "./ManufacturerAppList.vue?vue&type=template&id=3ef0f85f&scoped=true"
import script from "./ManufacturerAppList.vue?vue&type=script&lang=js"
export * from "./ManufacturerAppList.vue?vue&type=script&lang=js"

import "./ManufacturerAppList.vue?vue&type=style&index=0&id=3ef0f85f&scoped=true&lang=css"

import exportComponent from "/var/lib/docker/jenkins_home/workspace/play-spider-web-prod-s3-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ef0f85f"]])

export default __exports__